import { IonButton, IonCol, IonGrid, IonRefresher, IonRefresherContent, IonRow } from '@ionic/react';
import React, { useState } from 'react';
import { withRouter } from 'react-router';
import { getConfig } from '../../appConfig';
import { NormalText, SmallText, Spacer, StrongText, Subtitle, Title } from '../../components/common';
import Basket from '../../lib/basket';
import { withTranslation } from '../../lib/translate';
import { forwardTo, isDefined } from '../../lib/utils';
import { showToast } from '../../store/actions';
import moment from 'moment';
import { ReactComponent as Repeat } from '../../assets/images/reorder.svg';
import { ReactComponent as NoLoyaltyIcon } from '../../assets/images/no-data-loyalty-icon.svg';
import { ReactComponent as NoOrderIcon } from '../../assets/images/no-data-order-icon.svg';
import { isStoreOpened } from '../clickAndCollect';

const HistoryTab = withRouter(({ __, transactionHistory, getTransactionHistory, history, restaurants, dispatch, ...rest }) => {
	const [page, setpage] = useState(1);
	const type = rest.type || 'order';
	const isOrderPage = type === 'order';
	const { disableHistoryPagination } = getConfig()?.flags;
	const doRefresh = (event, getTransactionHistory) => {
		setTimeout(() => {
			event.detail.complete();
			getTransactionHistory(page, !isOrderPage, isOrderPage);
		}, 1000);
	};

	const handleRowClick = (item) => {
		if (type === 'order') {
			history.push('./history-details', { order: item });
		} else {
			// history.push('./history-details')
		}
	};
	const delivery = isDefined(getConfig().delivery) ? getConfig().delivery : [];
	const deliveryOptionsCards = (getConfig().dashboardConfig?.data || []).filter((item) => item.path === '/delivery-options');
	const orderAgain = (past_orders, option) => {
		const restaurant = restaurants.filter((restaurant) => restaurant.id === past_orders.restaurant_id);
		if (restaurant.length > 0) {
			Basket.reset();
			Basket.setDeliveryOption(option);
			forwardTo(option.route, { selectedRestaurant: past_orders, reorder: true });
		} else {
			dispatch(showToast('This restaurant is no longer receiving orders.', 'warning'));
		}
	};
	const showMore = () => {
		const newPage = page + 1;
		setpage(newPage)
		getTransactionHistory(newPage, !isOrderPage, isOrderPage);
	};
	return (
		<>
			<IonRefresher slot="fixed" onIonRefresh={(e) => doRefresh(e, getTransactionHistory)}>
				<IonRefresherContent></IonRefresherContent>
			</IonRefresher>
			{type === 'order' &&
				<>
					{deliveryOptionsCards.length > 0 && (
						<div className="dashboard-content">
							<div className="dashboard-cards-wrapper" style={{ paddingBottom: 0 }}>
								{deliveryOptionsCards.map((item, i) => (
									<div style={{marginBottom:'10px'}} key={i} className="dashboard-card" onClick={() => forwardTo(item.path)}>
										<img src={item.image} />
										<Title style={{ textAlign: 'center' }}>{__(item.title)}</Title>
									</div>
								))}
							</div>
						</div>
					)}
				</>
			}

			<div className={`history-content ${type !== '' ? `${type}-tab` : ''}`}>
				{(transactionHistory || []).length === 0 ? (
					type === 'order' ? (
						<div className="no-data-history">
							<NoOrderIcon />
							<Spacer size={1} />
							<Title>{__('No orders yet')}</Title>
							<Spacer size={1} />
							<NormalText>{__('Your order history will be shown here as soon as you place your first order')}</NormalText>
						</div>
					) : (
						<div className="no-data-history">
							<NoLoyaltyIcon />
							<Spacer size={1} />
							<Title>{__('No vouchers yet')}</Title>
							<Spacer size={1} />
							<NormalText>{__('Your voucher and loyalty points will be shown here as soon as you receive them')}</NormalText>
						</div>
					)
				) : (
					<>
						<IonGrid class="box-wrapper">
							{transactionHistory.map((i, index) => {
								const { stamp_power, transaction_date, label, item, location_name, is_points, is_stamps, is_vouchers, is_visit, reason_balance } = i;
								const withoutZ = transaction_date ? transaction_date?.replace('Z', '') : moment().tz(getConfig().timezone);
								const transDate = Basket.getDate(withoutZ);
								let orderLabel = Basket.getOrderType(i.item);
								let option = (delivery || []).find((d) => d.id === orderLabel);
								let orderId = i && i.item ? ' #' + i.item.id : '';
								let status = item && item.status ? item.status : '';
								status = status.toUpperCase();
								const paymentToken = item ? item.payment_token : '';
								let locationName = location_name && location_name !== '' ? location_name : i && i.item ? i.item.restaurant_name : '';
								const showItem = paymentToken === 'Pay on collection' || paymentToken === 'Pay to the driver' || (status !== 'CREATED' && status !== 'NEW');
								const orderCreatedAt = item && item?.created_at ? moment(item.created_at).format(`LLLL [${__('at')}] h:mm a`) : '';
								return (
									showItem && (
										<IonRow key={index} className="history-item">
											<IonCol size="8" onClick={() => handleRowClick(item)}>
												{!item?.is_gift && !item?.is_event ? (
													<>
														{locationName &&
															<div className='ellipsis small-text text-to-update'>{locationName}</div>
														}
														{is_vouchers &&
															<div className='ellipsis small-text text-to-update'>{__(reason_balance)}</div>
														}
														<StrongText className={` break-spaces uppercase block text-to-update`}>
															{type === 'order' ? (orderLabel ? __(orderLabel) + orderId : '') : __(label)}
														</StrongText>

														<SmallText className=" break-spaces">
															{`${__(transDate.format('DD MMM YYYY'))} ${__('at')} ${item?.additional_data?.named_time_slots_data ? item.additional_data?.named_time_slots_data : transDate.format('h:mm a')}`}
														</SmallText>
													</>
												) : (
													<>
														<StrongText className="break-spaces uppercase block">
															{__('eGift voucher')} {orderId}
														</StrongText>
														{orderCreatedAt ? <SmallText className=" break-spaces">{orderCreatedAt}</SmallText> : null}
													</>
												)}
											</IonCol>
											{type === 'order' ? (
												!item?.is_gift &&
												!item?.is_event &&
												!Basket.has_multi_basket && (
													<IonCol
														size="4"
														style={{
															alignSelf: 'center',
															textAlign: 'end',
														}}
														className="order-button-col-width"
													>
														<IonButton color="primary" className="small-btn button-uppercase" onClick={() => orderAgain(item, option)}>
															{getConfig().flags.hasIconOnReorder &&
																<Repeat />
															}
															{__('Reorder')}
														</IonButton>
													</IonCol>
												)
											) : (
												<>

													<IonCol
														style={{
															alignSelf: 'center',
															display: 'grid',
															justifyContent: 'flex-end',
														}}
													>
														{!is_vouchers &&
															<div className="transaction-points-wrapper">

																<Subtitle className={is_vouchers ? 'bold' : stamp_power < 0 ? 'bold danger-color' : 'bold success-color'}>

																	<>
																		{stamp_power < 0 ? '-' : '+'}
																		{Math.abs(stamp_power)}
																	</>
																</Subtitle>


																{is_visit ? (
																	<SmallText>{Math.abs(stamp_power) == 1 ? __('visit') : __('visits')}</SmallText>
																) : is_stamps ? (
																	<SmallText>{Math.abs(stamp_power) == 1 ? __('stamp') : __('stamps')}</SmallText>
																) : is_points ? (
																	<SmallText>{Math.abs(stamp_power) == 1 ? __('point') : __('points')}</SmallText>
																) : null}
															</div>
														}

													</IonCol>
												</>

											)}
										</IonRow>
									)
								);
							})}
						</IonGrid>
						<Spacer size={5} />
						{disableHistoryPagination || (transactionHistory || []).length < page * 10 ? null : (
							<IonButton onClick={() => showMore()} color='secondary' className="link">
								{__('Show more')}
							</IonButton>
						)}
					</>
				)}
			</div>
		</>
	);
});

export default withTranslation(HistoryTab);
